import notFound from './../NotFoundView.vue'

export const errorsPage = [
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: notFound
  },
  {
    path: '/error',
    name: 'page-error',
    component: notFound
  }
]
